"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = exports.MTableToolbar = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _classnames = _interopRequireDefault(require("classnames"));

var _filefy = require("filefy");

var _propTypes = _interopRequireWildcard(require("prop-types"));

require("jspdf-autotable");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var jsPDF = typeof window !== "undefined" ? require("jspdf").jsPDF : null;
/* eslint-enable no-unused-vars */

var MTableToolbar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MTableToolbar, _React$Component);

  var _super = _createSuper(MTableToolbar);

  function MTableToolbar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MTableToolbar);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchChange", function (searchText) {
      _this.props.dataManager.changeSearchText(searchText);

      _this.setState({
        searchText: searchText
      }, _this.props.onSearchChanged(searchText));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTableData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var columns, data;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              columns = _this.props.columns.filter(function (columnDef) {
                return (!columnDef.hidden || columnDef.export === true) && columnDef.export !== false && columnDef.field;
              }).sort(function (a, b) {
                return a.tableData.columnOrder > b.tableData.columnOrder ? 1 : -1;
              });

              if (!_this.props.exportAllData) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return Promise.resolve(_this.getAllData());

            case 4:
              _context.t0 = _context.sent;
              _context.next = 8;
              break;

            case 7:
              _context.t0 = _this.props.renderData;

            case 8:
              data = _context.t0.map(function (rowData) {
                return columns.map(function (columnDef) {
                  return _this.props.getFieldValue(rowData, columnDef);
                });
              });
              return _context.abrupt("return", [columns, data]);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAllData", function () {
      if (typeof _this.props.remoteDataGetter === "function") return _this.props.remoteDataGetter();else return _this.props.data;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defaultExportCsv", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _yield$_this$getTable, _yield$_this$getTable2, columns, data, fileName, builder;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.getTableData();

            case 2:
              _yield$_this$getTable = _context2.sent;
              _yield$_this$getTable2 = (0, _slicedToArray2.default)(_yield$_this$getTable, 2);
              columns = _yield$_this$getTable2[0];
              data = _yield$_this$getTable2[1];
              fileName = _this.props.title || "data";

              if (_this.props.exportFileName) {
                fileName = typeof _this.props.exportFileName === "function" ? _this.props.exportFileName() : _this.props.exportFileName;
              }

              builder = new _filefy.CsvBuilder(fileName + ".csv");
              builder.setDelimeter(_this.props.exportDelimiter).setColumns(columns.map(function (columnDef) {
                return columnDef.title;
              })).addRows(data).exportFile();

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defaultExportPdf", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _yield$_this$getTable3, _yield$_this$getTable4, columns, data, content, unit, size, orientation, doc;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(jsPDF !== null)) {
                _context3.next = 16;
                break;
              }

              _context3.next = 3;
              return _this.getTableData();

            case 3:
              _yield$_this$getTable3 = _context3.sent;
              _yield$_this$getTable4 = (0, _slicedToArray2.default)(_yield$_this$getTable3, 2);
              columns = _yield$_this$getTable4[0];
              data = _yield$_this$getTable4[1];
              content = {
                startY: 50,
                head: [columns.map(function (columnDef) {
                  return columnDef.title;
                })],
                body: data
              };
              unit = "pt";
              size = "A4";
              orientation = "landscape";
              doc = new jsPDF(orientation, unit, size);
              doc.setFontSize(15);
              doc.text(_this.props.exportFileName || _this.props.title, 40, 40);
              doc.autoTable(content);
              doc.save((_this.props.exportFileName || _this.props.title || "data") + ".pdf");

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "exportCsv", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this.props.exportCsv) {
                _context4.next = 4;
                break;
              }

              _this.props.exportCsv(_this.props.columns, _this.props.data);

              _context4.next = 6;
              break;

            case 4:
              _context4.next = 6;
              return _this.defaultExportCsv();

            case 6:
              _this.setState({
                exportButtonAnchorEl: null
              });

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "exportPdf", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!_this.props.exportPdf) {
                _context5.next = 4;
                break;
              }

              _this.props.exportPdf(_this.props.columns, _this.props.data);

              _context5.next = 6;
              break;

            case 4:
              _context5.next = 6;
              return _this.defaultExportPdf();

            case 6:
              _this.setState({
                exportButtonAnchorEl: null
              });

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    _this.state = {
      columnsButtonAnchorEl: null,
      exportButtonAnchorEl: null,
      searchText: props.searchText
    };
    return _this;
  }

  (0, _createClass2.default)(MTableToolbar, [{
    key: "renderSearch",
    value: function renderSearch() {
      var _this2 = this;

      var localization = (0, _objectSpread2.default)({}, MTableToolbar.defaultProps.localization, this.props.localization);

      if (this.props.search) {
        return /*#__PURE__*/React.createElement(_TextField.default, {
          autoFocus: this.props.searchAutoFocus,
          className: this.props.searchFieldAlignment === "left" && this.props.showTitle === false ? null : this.props.classes.searchField,
          value: this.state.searchText,
          onChange: function onChange(event) {
            return _this2.onSearchChange(event.target.value);
          },
          placeholder: localization.searchPlaceholder,
          variant: this.props.searchFieldVariant,
          InputProps: {
            startAdornment: /*#__PURE__*/React.createElement(_InputAdornment.default, {
              position: "start"
            }, /*#__PURE__*/React.createElement(_Tooltip.default, {
              title: localization.searchTooltip
            }, /*#__PURE__*/React.createElement(this.props.icons.Search, {
              fontSize: "small"
            }))),
            endAdornment: /*#__PURE__*/React.createElement(_InputAdornment.default, {
              position: "end"
            }, /*#__PURE__*/React.createElement(_IconButton.default, {
              disabled: !this.state.searchText,
              onClick: function onClick() {
                return _this2.onSearchChange("");
              },
              "aria-label": localization.clearSearchAriaLabel
            }, /*#__PURE__*/React.createElement(this.props.icons.ResetSearch, {
              fontSize: "small",
              "aria-label": "clear"
            }))),
            style: this.props.searchFieldStyle,
            inputProps: {
              "aria-label": localization.searchAriaLabel
            }
          }
        });
      } else {
        return null;
      }
    }
  }, {
    key: "renderDefaultActions",
    value: function renderDefaultActions() {
      var _this3 = this;

      var localization = (0, _objectSpread2.default)({}, MTableToolbar.defaultProps.localization, this.props.localization);
      var classes = this.props.classes;
      return /*#__PURE__*/React.createElement("div", null, this.props.columnsButton && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Tooltip.default, {
        title: localization.showColumnsTitle
      }, /*#__PURE__*/React.createElement(_IconButton.default, {
        color: "inherit",
        onClick: function onClick(event) {
          return _this3.setState({
            columnsButtonAnchorEl: event.currentTarget
          });
        },
        "aria-label": localization.showColumnsAriaLabel
      }, /*#__PURE__*/React.createElement(this.props.icons.ViewColumn, null))), /*#__PURE__*/React.createElement(_Menu.default, {
        anchorEl: this.state.columnsButtonAnchorEl,
        open: Boolean(this.state.columnsButtonAnchorEl),
        onClose: function onClose() {
          return _this3.setState({
            columnsButtonAnchorEl: null
          });
        }
      }, /*#__PURE__*/React.createElement(_MenuItem.default, {
        key: "text",
        disabled: true,
        style: {
          opacity: 1,
          fontWeight: 600,
          fontSize: 12
        }
      }, localization.addRemoveColumns), this.props.columns.map(function (col) {
        if (!col.hidden || col.hiddenByColumnsButton) {
          return /*#__PURE__*/React.createElement("li", {
            key: col.tableData.id
          }, /*#__PURE__*/React.createElement(_MenuItem.default, {
            className: classes.formControlLabel,
            component: "label",
            htmlFor: "column-toggle-".concat(col.tableData.id),
            disabled: col.removable === false
          }, /*#__PURE__*/React.createElement(_Checkbox.default, {
            checked: !col.hidden,
            id: "column-toggle-".concat(col.tableData.id),
            onChange: function onChange() {
              return _this3.props.onColumnsChanged(col, !col.hidden);
            }
          }), /*#__PURE__*/React.createElement("span", null, col.title)));
        }

        return null;
      }))), this.props.exportButton && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Tooltip.default, {
        title: localization.exportTitle
      }, /*#__PURE__*/React.createElement(_IconButton.default, {
        color: "inherit",
        onClick: function onClick(event) {
          return _this3.setState({
            exportButtonAnchorEl: event.currentTarget
          });
        },
        "aria-label": localization.exportAriaLabel
      }, /*#__PURE__*/React.createElement(this.props.icons.Export, null))), /*#__PURE__*/React.createElement(_Menu.default, {
        anchorEl: this.state.exportButtonAnchorEl,
        open: Boolean(this.state.exportButtonAnchorEl),
        onClose: function onClose() {
          return _this3.setState({
            exportButtonAnchorEl: null
          });
        }
      }, (this.props.exportButton === true || this.props.exportButton.csv) && /*#__PURE__*/React.createElement(_MenuItem.default, {
        key: "export-csv",
        onClick: this.exportCsv
      }, localization.exportCSVName), (this.props.exportButton === true || this.props.exportButton.pdf) && /*#__PURE__*/React.createElement(_MenuItem.default, {
        key: "export-pdf",
        onClick: this.exportPdf
      }, localization.exportPDFName))), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(this.props.components.Actions, {
        actions: this.props.actions && this.props.actions.filter(function (a) {
          return a.position === "toolbar";
        }),
        components: this.props.components
      })));
    }
  }, {
    key: "renderSelectedActions",
    value: function renderSelectedActions() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(this.props.components.Actions, {
        actions: this.props.actions.filter(function (a) {
          return a.position === "toolbarOnSelect";
        }),
        data: this.props.selectedRows,
        components: this.props.components
      }));
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var classes = this.props.classes;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.actions
      }, /*#__PURE__*/React.createElement("div", null, this.props.selectedRows && this.props.selectedRows.length > 0 ? this.renderSelectedActions() : this.renderDefaultActions()));
    }
  }, {
    key: "renderToolbarTitle",
    value: function renderToolbarTitle(title) {
      var classes = this.props.classes;
      var toolBarTitle = typeof title === "string" ? /*#__PURE__*/React.createElement(_Typography.default, {
        variant: "h6",
        style: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }, title) : title;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.title
      }, toolBarTitle);
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      var localization = (0, _objectSpread2.default)({}, MTableToolbar.defaultProps.localization, this.props.localization);
      var title = this.props.showTextRowsSelected && this.props.selectedRows && this.props.selectedRows.length > 0 ? typeof localization.nRowsSelected === "function" ? localization.nRowsSelected(this.props.selectedRows.length) : localization.nRowsSelected.replace("{0}", this.props.selectedRows.length) : this.props.showTitle ? this.props.title : null;
      return /*#__PURE__*/React.createElement(_Toolbar.default, {
        className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.highlight, this.props.showTextRowsSelected && this.props.selectedRows && this.props.selectedRows.length > 0))
      }, title && this.renderToolbarTitle(title), this.props.searchFieldAlignment === "left" && this.renderSearch(), this.props.toolbarButtonAlignment === "left" && this.renderActions(), /*#__PURE__*/React.createElement("div", {
        className: classes.spacer
      }), this.props.searchFieldAlignment === "right" && this.renderSearch(), this.props.toolbarButtonAlignment === "right" && this.renderActions());
    }
  }]);
  return MTableToolbar;
}(React.Component);

exports.MTableToolbar = MTableToolbar;
MTableToolbar.defaultProps = {
  actions: [],
  columns: [],
  columnsButton: false,
  localization: {
    addRemoveColumns: "Add or remove columns",
    nRowsSelected: "{0} row(s) selected",
    showColumnsTitle: "Show Columns",
    showColumnsAriaLabel: "Show Columns",
    exportTitle: "Export",
    exportAriaLabel: "Export",
    exportCSVName: "Export as CSV",
    exportPDFName: "Export as PDF",
    searchTooltip: "Search",
    searchPlaceholder: "Search",
    searchAriaLabel: "Search",
    clearSearchAriaLabel: "Clear Search"
  },
  search: true,
  showTitle: true,
  searchText: "",
  showTextRowsSelected: true,
  toolbarButtonAlignment: "right",
  searchAutoFocus: false,
  searchFieldAlignment: "right",
  searchFieldVariant: "standard",
  selectedRows: [],
  title: "No Title!"
};
MTableToolbar.propTypes = {
  actions: _propTypes.default.array,
  columns: _propTypes.default.array,
  columnsButton: _propTypes.default.bool,
  components: _propTypes.default.object.isRequired,
  getFieldValue: _propTypes.default.func.isRequired,
  localization: _propTypes.default.object.isRequired,
  onColumnsChanged: _propTypes.default.func.isRequired,
  dataManager: _propTypes.default.object.isRequired,
  searchText: _propTypes.default.string,
  onSearchChanged: _propTypes.default.func.isRequired,
  search: _propTypes.default.bool.isRequired,
  searchFieldStyle: _propTypes.default.object,
  searchFieldVariant: _propTypes.default.string,
  selectedRows: _propTypes.default.array,
  title: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  showTitle: _propTypes.default.bool.isRequired,
  showTextRowsSelected: _propTypes.default.bool.isRequired,
  toolbarButtonAlignment: _propTypes.default.string.isRequired,
  searchFieldAlignment: _propTypes.default.string.isRequired,
  remoteDataGetter: _propTypes.default.func,
  renderData: _propTypes.default.array,
  data: _propTypes.default.array,
  exportAllData: _propTypes.default.bool,
  exportButton: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    csv: _propTypes.default.bool,
    pdf: _propTypes.default.bool
  })]),
  exportDelimiter: _propTypes.default.string,
  exportFileName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  exportCsv: _propTypes.default.func,
  exportPdf: _propTypes.default.func,
  classes: _propTypes.default.object,
  searchAutoFocus: _propTypes.default.bool
};

var styles = function styles(theme) {
  return {
    root: {
      paddingRight: theme.spacing(1)
    },
    highlight: theme.palette.type === "light" ? {
      color: theme.palette.secondary.main,
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.85)
    } : {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.dark
    },
    spacer: {
      flex: "1 1 10%"
    },
    actions: {
      color: theme.palette.text.secondary
    },
    title: {
      overflow: "hidden"
    },
    searchField: {
      minWidth: 150,
      paddingLeft: theme.spacing(2)
    },
    formControlLabel: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }
  };
};

exports.styles = styles;

var _default = (0, _withStyles.default)(styles)(MTableToolbar);

exports.default = _default;